import styled from "@emotion/styled";
export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;


export const ModalImageContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 8px;
`;
export const Image = styled.img`
  width: 823px;
  height: 301px;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;
